export interface PortfolioCase {
  id: string;
  company: string;
  title: string;
  description: string;
  image: string;
  contentFile: string;
  slug: string;
  isBig?: boolean;
  cta: string;
}

export const portfolioCases: PortfolioCase[] = [
  {
    id: 'Panasonic_Well',
    company: 'Panasonic Well',
    title: 'Strategic foundation work the company recognized as its own.',
    description: 'Meeting the needs of modern families with a strategic foundation that turned out to be the company’s own founding philosophy.',
    image: '/assets/images/PanasonicWell_CES_Keynote.webp',
    contentFile: 'Panasonic_Well',
    slug: 'panasonic-well',
    isBig: true,
    cta: 'View Case Study'
  },{
    id: 'AvenueM',
    company: 'Avenue M',
    title: 'Adopting AI where the output has to survive a courtroom.',
    description: 'Defensibility as an architectural property: 6–10 weeks of valuation work compressed to 6–10 days.',
    image: '/assets/images/Box_shoot.jpg',
    contentFile: 'AvenueM',
    slug: 'avenue-m',
    cta: 'View Case Study'
  },{
    id: 'Stitch',
    company: 'Stitch Fix',
    title: 'From transactional retailer to continuous style platform.',
    description: 'Far past a brand problem, to ask the question about what kind of company Stitch Fix was becoming.',
    image: '/assets/images/SF_WeSeeYou_rev.jpg',
    contentFile: 'stitch',
    slug: 'stitch-fix',
    cta: 'View Case Study'
  },{
    id: 'Box',
    company: 'Box',
    title: 'Claiming the quadrant the enterprise software industry didn’t believe existed.',
    description: 'Enterprise software made culturally legible at consumer-brand altitude.',
    image: '/assets/images/Box_workasone_wickens.jpg',
    contentFile: 'Box_workasone',
    slug: 'box',
    cta: 'View Case Study'
  },{
    id: 'HP_brandstrategy',
    company: 'HP',
    title: 'Brand work at the altitude of a category.',
    description: 'Drawing from Bill and Dave’s founding philosophy to build the brand strategy that held through three CEOs.',
    image: '/assets/images/HP_purpose_splits.jpg',
    contentFile: 'HP_brandstrategy',
    slug: 'hp',
    isBig: true,
    cta: 'View Case Study'
  },{
    id: 'Conde_Nast',
    company: 'Condé Nast',
    title: 'Recasting the world’s foremost publisher into a premium media network.',
    description: 'Where brand strategy and editorial sensibility become the same craft.',
    image: '/assets/images/Conde_hero.jpg',
    contentFile: 'Conde_Nast',
    slug: 'conde-nast',
    isBig: true,
    cta: 'View Case Study'
  }
];


export const portfolioVisions: PortfolioCase[] = [
 {
    id: 'insights-driven-cultures',
    company: 'Approach: Consumer Insights',
    title: 'Start with Discovering the Human Truth',
    description: 'Get in front of consumers early and often, because the world changes quickly.',
    image: '/assets/images/ig_insights.png',
    contentFile: 'insights-driven-cultures',
    slug: 'insights-driven-cultures',
    cta: 'Read More'
  },{
    id: 'market-understanding',
    company: 'Approach: Market Context',
    title: 'Get Specific About Differentiation and Levers for Growth',
    description: 'Analyze the landscape and technology shifts to identify transformation timing.',
    image: '/assets/images/ig_market.png',
    contentFile: 'market-understanding',
    slug: 'market-understanding',
    cta: 'Read More'
  },{
    id: 'rapid-ideation',
    company: 'Approach: Rapid Ideation',
    title: 'Rapidly Generate Ideas, Validate, and Iterate',
    description: 'Design buildable product concepts that make new portfolio strategies tangible.',
    image: '/assets/images/ig_ideation.png',
    contentFile: 'rapid-ideation',
    slug: 'rapid-ideation',
    cta: 'Read More'
  },{
    id: 'organizational-alignment',
    company: 'Approach: Organizational Alignment',
    title: 'Contagious Co-Creation',
    description: 'Cross-functional teams need to be on the journey, fed with concrete ideas, roadmaps and visions.',
    image: '/assets/images/ig_alignment.png',
    contentFile: 'organizational-alignment',
    slug: 'organizational-alignment',
    cta: 'Read More'
  }

];
